import React, {
  FormEvent,
  MouseEvent,
  ReactNode,
  useState,
  useRef,
  useEffect,
} from "react";
import "./input.scss";
import { useField } from "formik";
import Info from "../SVG/Info";
import { ReactComponent as Upload } from "../../../assets/svg/UploadFile.svg";
import { ReactComponent as Delete } from "../../../assets/svg/DeleteFile.svg";
import { UploadFile } from "@mui/icons-material";

interface InputProps {
  value?: string;
  disabled?: boolean;
  type?: "file";
  label?: string;
  name?: string;
  showHelpTextIcon?: boolean;
  labelHelpText?: string | ReactNode;
  required?: boolean;
  placeholder?: string;
  labelSuffix?: ReactNode;
  errorMsg?: string;
  accept?: string;
  image?: ReactNode;
  fileName?: string | null;
  fileUrl?: string | null;
  as?: string;
  infoIconProps?: any;
  readonly?: boolean;
  onClick?: (e: MouseEvent) => void;
  onInput?: (e: FormEvent) => void;
  onClear?: (e: any) => void;
  onChange?: (e: any) => void;
}

const FileUpload: React.FC<InputProps> = ({
  onClear,
  onChange,
  label,
  required,
  disabled,
  labelSuffix,
  readonly,
  errorMsg,
  labelHelpText,
  accept,
  image,
  fileName,
  fileUrl,
  ...props
}) => {
  const [type, setType] = useState("file");
  const inputRef = useRef(null);
  const [file, setFile] = useState<any>(fileUrl || "");
  //const [field, meta] = useField(props as any);
  useEffect(() => {
    setFile(fileUrl);
  }, [fileUrl]);

  return (
    <div className="file-upload input-group">
      {/* <Upload /> */}
      {label && (
        <label className="align-items-center d-flex">
          {label}
          {labelSuffix && (
            <span className="ms-2">{labelSuffix && labelSuffix}</span>
          )}
          {required && <span className="required">*</span>}
          {labelHelpText && (
            <span className="help-icon ">
              <Info {...props.infoIconProps} />
              <div className="help-info">{labelHelpText}</div>
            </span>
          )}
        </label>
      )}

      <div
        className={`file-input-control ${disabled && "input-disabled"} ${
          readonly && "input-readonly "
        } ${errorMsg && "error"}`}
      >
        <input
          {...props}
          type={type}
          ref={inputRef}
          //{...field}
          accept={accept}
          onChange={onChange}
          disabled={disabled}
          style={{ display: "none" }}
          value={props?.value ? props?.value : ""}
          onInput={(e) => {
            let data = (e.target as any).files[0];
            setFile(URL.createObjectURL((e.target as any).files[0]));
            props.onInput && props?.onInput(e);
          }}
        ></input>
        <div
          onClick={() => {
            (inputRef.current as any).click();
          }}
          className="upload-button"
          id="upload-button"
        >
          <Upload width={24} height={24} />
        </div>
        {/* {fileName && (
          <div className="fileName-section align-self-center">
            <img src={file} />
            <div
              onClick={(e) => {
                onClear && onClear(e);
              }}
              className={`affix-clear`}
              title="clear"
            >
              <Delete />
            </div>
          </div>
        )} */}
      </div>
      {errorMsg && (
        <div className="error-message">
          <span className="custom-error-message">{errorMsg}</span>
        </div>
      )}
    </div>
  );
};
export default FileUpload;
